$(function () {
    $('.action-new-rangerepeater').click(function () {
        var $el = $(this).parents('.rangerepeat-container');
        var newRowHtml = $el.find('.rangerepeater-template').html();
        $el.find('.rangerepeat-repeater').append($(newRowHtml));
        $(this).trigger('freshEnds');
    }).on('freshEnds', function () {
        var $el = $(this).parents('.rangerepeat-container');
        $el.find('.rangerepeat-repeater .rr-l[disabled],.rangerepeat-repeater .rr-r[disabled]').attr('disabled', false).val('').attr('required', true);
        $el.find('.rangerepeat-repeater .rr-l:first').attr('disabled', true).attr('required', false).val('')
        $el.find('.rangerepeat-repeater .rr-r:last').attr('disabled', true).attr('required', false).val('')
        $el.find('.rangerepeat-repeater .rr-v').attr('required', true)
    }).trigger('freshEnds')
        .each(function () {
            $('.rangerepeat-repeater').on('keydown keyup change', '.rr-l', function () {
                $(this).parents('.rangerepeater-row').prev().find('.rr-r').val($(this).val())
            })
            $('.rangerepeat-repeater').on('keydown keyup change', '.rr-r', function () {
                $(this).parents('.rangerepeater-row').next().find('.rr-l').val($(this).val())
            })
            $('.rangerepeat-repeater').on('change regen', 'input', function () {
                var data = {};
                var $el = $(this).parents('.rangerepeat-container');
                $el.find('.rangerepeat-repeater .rangerepeater-row').each(function () {
                    data[($(this).find('.rr-l').val() || 0) + '/' + ($(this).find('.rr-r').val() || 0)] = $(this).find('.rr-v').val();
                })
                $el.find('.rr-val').val(JSON.stringify(data));
            });
            var data = {};
            var $el = $(this).parents('.rangerepeat-container');
            $el.find('.rangerepeat-repeater .rangerepeater-row').each(function () {
                data[($(this).find('.rr-l').val() || 0) + '/' + ($(this).find('.rr-r').val() || 0)] = $(this).find('.rr-v').val();
            })
            $el.find('.rr-val').val(JSON.stringify(data));
        })
})


$(function () {
    $('.action-new-keyrepeater').click(function () {
        var $el = $(this).parents('.keyvalue-container');
        var newRowHtml = $el.find('.keyrepeater-template').html();
        $el.find('.keyvalue-repeater').append($(newRowHtml));
        $(this).trigger('freshEnds');
    })
        .each(function () {
            var $this = $(this);
            var recalc = function () {
                var data = {};
                var $el = $this.parents('.keyvalue-container');
                $el.find('.keyvalue-repeater .keyrepeater-row').each(function () {
                    data[$(this).find('.kv-k').val()] = $(this).find('.kv-v').val();
                })
                $el.find('.rk-val').val(JSON.stringify(data));
            };

            $('.keyvalue-repeater').on('change', 'input,select', function () {
                recalc()

            });
            recalc()
            $('.keyvalue-repeater').on('click', '.action-delete-row', function () {
                $(this).parents('.keyrepeater-row').remove();
                recalc()

            })
        })
})


